import * as events from '../base/constant';
import { Grid, getObject, Print as GridPrint } from '@syncfusion/ej2-grids';
import { addClass } from '@syncfusion/ej2-base';
/**
 * TreeGrid Print module
 *
 * @hidden
 */
export class Print {
    /**
     * Constructor for Print module
     *
     * @param {TreeGrid} parent - Tree Grid instance
     */
    constructor(parent) {
        this.parent = parent;
        Grid.Inject(GridPrint);
        this.addEventListener();
    }
    /**
     * For internal use only - Get the module name.
     *
     * @private
     * @returns {string} Returns Print module name
     */
    getModuleName() {
        return 'print';
    }
    /**
     * @hidden
     * @returns {void}
     */
    addEventListener() {
        this.parent.grid.on(events.printGridInit, this.printTreeGrid, this);
    }
    removeEventListener() {
        this.parent.grid.off(events.printGridInit, this.printTreeGrid);
    }
    printTreeGrid(printGrid) {
        const grid = getObject('printgrid', printGrid);
        const gridElement = getObject('element', printGrid);
        grid.addEventListener(events.queryCellInfo, this.parent.grid.queryCellInfo);
        grid.addEventListener(events.rowDataBound, this.parent.grid.rowDataBound);
        grid.addEventListener(events.beforeDataBound, this.parent.grid.beforeDataBound);
        addClass([gridElement], 'e-treegrid');
    }
    print() {
        this.parent.grid.print();
    }
    /**
     * To destroy the Print
     *
     * @returns {void}
     * @hidden
     */
    destroy() {
        this.removeEventListener();
    }
}
